export default __webpack_public_path__ + "static/media/discordDeskFill.8bd2943a.svg";